<template>
  <div class="SaleHorseLampContainer leftCenter">
    <div class="leftCenter brd16 pd6" style="background: rgba(0, 0, 0, 0.8);">
      <img :src="data.buyerAvatar" class="sqr18 brd18 mr4"/>
      <nut-ellipsis :rows="1" :content="data.buyerName" class="ft12 wft" style="max-width: 100px"/>
      <span class="ft12 wft ml4">{{convertMillisecondsToMinutesSeconds(now-data.paidTimestamp)}}前购买了{{showGoodName?data.goodName:''}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SaleHorseLamp",
  props: {
    showGoodName:{
      type:Boolean,
      default:false,
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      now: new Date().getTime(),
    }
  },
  methods: {
    convertMillisecondsToMinutesSeconds(milliseconds) {
      // 将毫秒转换为秒
      var seconds = Math.floor(milliseconds / 1000);

      // 计算分钟数和剩余的秒数
      var minutes = Math.floor(seconds / 60);
      seconds = seconds % 60;

      // 返回格式化的时间字符串
      return minutes + "分" + seconds + "秒";
    },
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SaleHorseLampContainer {
  display: flex;
  flex-direction: row;
}
</style>